module.exports = __webpack_public_path__ + "b923cdc51380d53f8d99553b13fe33f7.jpg";